import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import { ApproveComponent } from './approve/approve.component';
import { ShowComponent } from './show/show.component';
import { UnauthorizeComponent } from './unauthorize/unauthorize.component';
// import { AppRoutingModule } from './app-routing.module'
import { DecryptionService } from 'src/shared/services/decryption.service';
import { AuthGuard } from './AuthGuard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationComponent } from './pagination/pagination.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ApproveServiceService } from 'src/shared/services/approve-service.service';
import { PaginateFunction } from '../shared/Common/paginate-function';
import { SideMenuComponent } from './side-menu/side-menu.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', component: AuthComponent },
  { path: 'side-menu', component: SideMenuComponent, canActivate: [AuthGuard] },
  { path: 'show', component: ShowComponent, canActivate: [AuthGuard] },
  { path: 'unauthorize', component: UnauthorizeComponent },
  { path: 'Approve', component: ApproveComponent, canActivate: [AuthGuard] },
  { path: 'thankyou', component: ThankYouComponent, canActivate: [AuthGuard] },
  { path: '**', component: UnauthorizeComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    UnauthorizeComponent,
    ShowComponent,
    ApproveComponent,
    PaginationComponent,
    ThankYouComponent,
    SideMenuComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    RouterModule.forRoot(routes),
    HttpClientModule,
    CheckboxModule

  ],
  providers: [DecryptionService, ApproveServiceService, PaginateFunction, { provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }
